<div class="modal-header">
  <h4 class="modal-title">{{ 'mooringPlace.modal.title' | translate }}</h4>

  <button class="btn-close" aria-label="Close"
    (click)="this.activeModal.close('close')">
  </button>
</div>

<div class="modal-body custom-layout">
  <form [formGroup]="mooringPlaceForm" class="m-0">

    <h6>{{ 'mooringPlace.modal.placeInformationTitle' | translate }}</h6>

    <!-- Mooring place information-->
    <div class="row">
      <div class="col-6">
        <label class="form-label" for="placeId">{{'mooringPlace.modal.placeId' | translate}}</label>
        @if (creationMode) {
          <span>*</span>
        }
      </div>
      <div class="col-6 text-end">
        @if (creationMode) {
          <input class="form-control" id="placeId" type="text"
            pattern="{{textInputPattern}}"
            formControlName="placeId" required>
        } @else {
          <p class="form-label">{{ mooringPlace.placeId }}</p>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label class="form-label" for="pontoon">{{'mooringPlace.modal.pontoon' | translate}}</label>
        @if (onlyPlaceInfo) {
          <span>*</span>
        }
      </div>
      <div class="col-6 text-end">
        @if (onlyPlaceInfo) {
          <input class="form-control" id="pontoon" type="text"
            pattern="{{textInputPattern}}"
            formControlName="pontoon" required>
        } @else {
          <p class="form-label">{{ mooringPlaceForm.value.pontoon }}</p>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label class="form-label" for="placeLabel">{{ 'mooringPlace.modal.placeNum' | translate }}</label>
        @if (onlyPlaceInfo) {
          <span>*</span>
        }
      </div>
      <div class="col-6 text-end">
        @if (onlyPlaceInfo) {
          <input class="form-control" id="placeLabel" type="text"
            pattern="{{textInputPattern}}"
            formControlName="placeNum" required>
        } @else {
          <p class="form-label">{{ mooringPlaceForm.value.placeNum }}</p>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label class="form-label" for="placeType">{{ 'mooringPlace.modal.placeType' | translate }}</label>
        @if (onlyPlaceInfo) {
          <span>*</span>
        }
      </div>
      <div class="col-6 text-end">
        @if (onlyPlaceInfo) {
          <input class="form-control" id="placeType" type="text"
            pattern="{{textInputPattern}}"
            formControlName="placeType" required>
        } @else {
          <p class="form-label">{{ mooringPlaceForm.value.placeType }}</p>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label class="form-label" for="placeWidth">{{ 'mooringPlace.modal.placeWidth' | translate }}</label>
        @if (onlyPlaceInfo) {
          <span>*</span>
        }
      </div>
      <div class="col-6 text-end">
        @if (onlyPlaceInfo) {
          <input class="form-control" id="placeWidth" type="number"
            step="0.01"
            formControlName="placeWidthInMeter" required>
        } @else {
          <p class="form-label">{{ mooringPlaceForm.value.placeWidthInMeter }}</p>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label class="form-label" for="placeLength">{{ 'mooringPlace.modal.placeLength' | translate }}</label>
        @if (onlyPlaceInfo) {
          <span>*</span>
        }
      </div>
      <div class="col-6 text-end">
        @if (onlyPlaceInfo) {
          <input class="form-control" id="placeLength" type="number"
            step="0.01"
            formControlName="placeLengthInMeter" required>
        } @else {
          <p class="form-label">{{ mooringPlaceForm.value.placeLengthInMeter }}</p>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label class="form-label" for="coordinateLatitude">{{ 'services.manage.coordinates.latitude' | translate }}</label>
        @if (onlyPlaceInfo) {
          <span>*</span>
        }
      </div>
      <div class="col-6 text-end">
        @if (onlyPlaceInfo) {
          <input class="form-control" type="text" id="coordinateLatitude"
            pattern="{{textInputPattern}}"
            formControlName="latitude" required>
        } @else {
          <p class="form-label">{{ mooringPlaceForm.value.latitude }}</p>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label class="form-label" for="coordinateLongitude">{{ 'services.manage.coordinates.longitude' | translate }}</label>
        @if (onlyPlaceInfo) {
          <span>*</span>
        }
      </div>
      <div class="col-6 text-end">
        @if (onlyPlaceInfo) {
          <input class="form-control" id="coordinateLongitude" type="text"
            pattern="{{textInputPattern}}"
            formControlName="longitude" required>
        } @else {
          <p class="form-label">{{ mooringPlaceForm.value.longitude }}</p>
        }
      </div>
    </div>

    @if (!onlyPlaceInfo) {
      <div class="row">
        <div class="col-6">
          <label class="form-label" for="subletYes">{{ 'mooringPlace.modal.sublet' | translate }}</label>
          @if (!previewMode) {
            <span>*</span>
          }
        </div>
        <div class="col-6 text-end">
          @if (!previewMode) {
            <fieldset class="btn-group">
              <input class="btn-check" id="subletYes" type="radio"
                [formControl]="sublet"
                [value]="true">
                <label class="btn btn-toggle btn-toggle-left h-auto"
                  for="subletYes"
                  [ngClass]="{ active: sublet.value }"
                  (click)="sublet.setValue(true)"
                (keyup)="sublet.setValue(true)">{{ 'common.yes' | translate }}</label>
                <input class="btn-check" id="subletNo" type="radio"
                  [formControl]="sublet"
                  [value]="false">
                  <label class="btn btn-toggle btn-toggle-right h-auto"
                    for="subletNo"
                    [ngClass]="{ active: !sublet.value }"
                    (click)="sublet.setValue(false)"
                  (keyup)="sublet.setValue(false)">{{ 'common.no' | translate }}</label>
                </fieldset>
              } @else {
                <p class="form-label">{{ (mooringPlace.sublet ? 'common.yes' : 'common.no') | translate }}</p>
              }
            </div>
          </div>
        }

        <!--Boat information-->
        @if (!onlyPlaceInfo) {
          <h6>{{ 'mooringPlace.modal.boatInformationTitle' | translate }}</h6>
          <div class="row">
            <div class="col-6">
              <label class="form-label" for="boatRegistrationNumber" translate="mooringPlace.modal.boatRegistrationNumber"></label>
            </div>
            <div class="col-6 text-end">
              @if (!previewMode) {
                <input class="form-control" type="text" id="boatRegistrationNumber"
                  pattern="{{textInputPattern}}"
                  formControlName="boatRegistrationNumber">
              } @else {
                <p class="form-label">{{ mooringPlaceForm.value.boatRegistrationNumber }}</p>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <label class="form-label" for="boatWidth" translate="mooringPlace.modal.boatWidth"></label>
            </div>
            <div class="col-6 text-end">
              @if (!previewMode) {
                <input class="form-control" id="boatWidth" type="number"
                  pattern="{{textInputPattern}}"
                  step="0.01"
                  formControlName="boatWidthInMeter">
              } @else {
                <p class="form-label">{{ mooringPlaceForm.value.boatWidthInMeter }}</p>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <label class="form-label" for="boatlength" translate="mooringPlace.modal.boatlength"></label>
            </div>
            <div class="col-6 text-end">
              @if (!previewMode) {
                <input class="form-control" id="boatLength" type="number"
                  pattern="{{textInputPattern}}"
                  step="0.01"
                  formControlName="boatLengthInMeter">
              } @else {
                <p class="form-label">{{ mooringPlaceForm.value.boatLengthInMeter }}</p>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <label class="form-label" for="boatWeight" translate="mooringPlace.modal.boatWeight"></label>
            </div>
            <div class="col-6 text-end">
              @if (!previewMode) {
                <input class="form-control" type="number" id="boatWeight"
                  pattern="{{textInputPattern}}"
                  formControlName="boatWeightInKg">
              } @else {
                <p class="form-label">{{ mooringPlaceForm.value.boatWeightInKg }}</p>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <label class="form-label" translate="mooringPlace.modal.boatType.label"></label>
            </div>
            <div class="col-8 text-end">
              @if (!previewMode) {
                <div>
                  @if (!previewMode) {
                    <fieldset class="btn-group">
                      <input class="btn-check" type="radio"
                        [formControl]="boatType"
                        [value]="BoatType.Motor">
                        <label class="btn btn-toggle btn-toggle-left h-auto"
                          [for]="boatType"
                          [ngClass]="{ active: boatType.value === BoatType.Motor }"
                          (click)="boatType.setValue(BoatType.Motor)"
                        (keyup)="boatType.setValue(BoatType.Motor)">{{ 'mooringPlace.modal.boatType.Motor' | translate }}</label>
                        <input class="btn-check" type="radio"
                          [formControl]="boatType"
                          [value]="BoatType.Sailing">
                          <label class="btn btn-toggle btn-toggle-left h-auto"
                            [ngClass]="{ active: boatType.value === BoatType.Sailing }"
                            [for]="boatType"
                            (click)="boatType.setValue(BoatType.Sailing)"
                          (keyup)="boatType.setValue(BoatType.Sailing)">{{ 'mooringPlace.modal.boatType.Sailing' | translate }}</label>
                          <input class="btn-check" type="radio"
                            [formControl]="boatType"
                            [value]="true">
                            <label class="btn btn-toggle btn-toggle-right h-auto"
                              [ngClass]="{ active: boatType.value === BoatType.Unknown }"
                              [for]="boatType"
                              (click)="boatType.setValue(BoatType.Unknown)"
                            (keyup)="boatType.setValue(BoatType.Unknown)">{{ 'mooringPlace.modal.boatType.Unknown' | translate }}</label>
                          </fieldset>
                        }
                      </div>
                    }
                    @if (previewMode && mooringPlaceForm.get('boatType').value) {
                      <p class="form-label">{{'mooringPlace.modal.boatType.'+ mooringPlaceForm.get('boatType').value | translate }}</p>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label class="form-label" for="draft">{{ 'mooringPlace.modal.draft' | translate }}</label>
                  </div>
                  <div class="col-6 text-end">
                    @if (!previewMode) {
                      <input class="form-control" type="text" id="draft"
                        pattern="{{textInputPattern}}"
                        formControlName="draft">
                    } @else {
                      <p class="form-label">{{ mooringPlaceForm.value.draft }}</p>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label class="form-label" for="remark">{{ 'mooringPlace.modal.remark' | translate }}</label>
                  </div>
                  <div class="col-6 text-end">
                    @if (!previewMode) {
                      <input class="form-control" type="text" id="remark"
                        pattern="{{textInputPattern}}"
                        formControlName="remark">
                    } @else {
                      <p class="form-label">{{ mooringPlaceForm.value.remark }}</p>
                    }
                  </div>
                </div>
                @if (!previewMode) {
                  <div class="row">
                    <div class="col-6">
                      <label class="form-label">{{ 'mooringPlace.modal.owner' | translate }}</label>
                    </div>
                    <div class="col-6 text-end">
                      <app-search-customer (selectedCustomerEvent)="selectCustomer($event)"
                      [customerContact]="selectedCustomer"></app-search-customer>
                    </div>
                  </div>
                }
              }

              <!--Owner information-->
              @if (previewMode && mooringPlace?.owner; as owner) {
                <h6>{{ 'mooringPlace.modal.boatOwnerInformationTitle' | translate }}</h6>
                <div class="row">
                  <div class="col-6">
                    <label class="form-label">{{ 'users.form.title.label' | translate }}</label>
                  </div>
                  <div class="col-6 text-end">
                    <p class="form-label">{{ 'users.form.title.'+owner.title | lowercase | translate }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <label class="form-label">{{ 'users.form.lastname' | translate }}</label>
                  </div>
                  <div class="col-8 text-end">
                    <p class="form-label">{{ owner.lastName | translate }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <label class="form-label">{{ 'users.form.firstname' | translate }}</label>
                  </div>
                  <div class="col-8 text-end">
                    <p class="form-label">{{ owner.firstName | translate }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <label class="form-label">{{ 'users.form.email' | translate }}</label>
                  </div>
                  <div class="col-8 text-end">
                    <p class="form-label">{{ owner.email | translate }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label class="form-label">{{ 'users.form.street' | translate }}</label>
                  </div>
                  <div class="col-6 text-end">
                    <p class="form-label">{{ owner.street | translate }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label class="form-label">{{ 'users.form.postalCode' | translate }}</label>
                  </div>
                  <div class="col-6 text-end">
                    <p class="form-label">{{ owner.postalCode | translate }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label class="form-label">{{ 'users.form.city' | translate }}</label>
                  </div>
                  <div class="col-6 text-end">
                    <p class="form-label">{{ owner.city | translate }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label class="form-label">{{ 'users.form.country' | translate }}</label>
                  </div>
                  <div class="col-6 text-end">
                    <p class="form-label">{{ owner.country | translate }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label class="form-label">{{ 'users.form.phone' | translate }}</label>
                  </div>
                  <div class="col-6 text-end">
                    <p class="form-label">{{ owner.phonePrivate | translate }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label class="form-label">{{ 'users.form.mobilePhone' | translate }}</label>
                  </div>
                  <div class="col-6 text-end">
                    <p class="form-label">{{ owner.phoneMobile | translate }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label class="form-label">{{ 'users.form.businessPhone' | translate }}</label>
                  </div>
                  <div class="col-6 text-end">
                    <p class="form-label">{{ owner.phoneProfessional  }}</p>
                  </div>
                </div>
              }
            </form>
          </div>

          <div class="modal-footer space-between">
            @if (!creationMode && !previewMode && onlyPlaceInfo) {
              <button class="btn btn-outline-danger"
                (click)="delete()"
                translate="services.actions.delete">
              </button>
            }

            <div>
              @if (creationMode || !previewMode) {
                <button class="btn btn-outline-secondary"
                  (click)="this.activeModal.close('close')"
                  translate="common.cancel">
                </button>
              }
              @if (creationMode || !previewMode) {
                <button class="btn btn-primary" [disabled]="mooringPlaceForm.invalid"
                  (click)="save()"
                  translate="common.save">
                </button>
              }
              @if (previewMode) {
                <button class="btn btn-primary"
                  (click)="toggleEdit()"
                  translate="common.tooltip.edit">
                </button>
              }
            </div>

          </div>
